import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Mail, Facebook, Linkedin, Instagram, Youtube } from 'lucide-react';

const locations = [
  {
    label: 'Palarivattom',
    name: 'Solace Neurobehavioral & Child Guidance Center',
    address: 'Pipeline Road, Near Karanakodam Kurisupally, Janatha Cross Road, Palarivattom, Kochi, Kerala 682025',
  },
  {
    label: 'Premier',
    name: 'Solace Premier',
    address: 'Kuzhikkattumoola, Kakkanad, Kochi, Kerala 682030',
  },
  {
    label: 'Kids',
    name: 'Solace Kids',
    address: 'Kuzhikkattumoola, Kakkanad, Kochi 682030',
  },
  {
    label: 'Village',
    name: 'Solace Village',
    address: 'Elampathu Road, Nilampathinjamugal Rajagiri Valley Rd, P O, Kakkanad, Kochi, Kerala 682039',
  },
  {
    label: 'Senior Care',
    name: 'Solace Senior Care',
    address: 'Near Olimugal Juma Masjid, Kakkanad 682030',
  },
];

const Footer = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Hospital Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="/assets/img/logo-footer.webp"
                alt="Solace Neuro Logo"
                className="h-12 w-auto"
              />
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Kochi's top destination for advanced psychiatric treatment and impactful therapy—guiding individuals toward stability, clarity, and emotional freedom.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/solace_neuro" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://www.facebook.com/SolaceNeuro" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://www.linkedin.com/company/solaceneuroekm/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="https://www.youtube.com/@solaceneurobehaviouralandc6656" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary transition-colors">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-300 hover:text-primary transition-colors">About Us</Link></li>
              <li><Link to="/doctors" className="text-gray-300 hover:text-primary transition-colors">Team</Link></li>
              <li><Link to="/gallery" className="text-gray-300 hover:text-primary transition-colors">Gallery</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-primary transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <div className="space-y-3 mb-4">
              <div className="flex items-start space-x-2">
                <Phone className="w-5 h-5 text-primary mt-0.5" />
                <a href="tel:+919746511100" className="text-gray-300 hover:text-primary transition-colors duration-200">
                  +91 97465 11100
                </a>
              </div>
              <div className="flex items-start space-x-2">
                <Mail className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                <a href="mailto:solaceneuro@gmail.com" className="text-gray-300 hover:text-primary transition-colors duration-200">
                  solaceneuro@gmail.com
                </a>
              </div>
            </div>

            {/* Location Tabs */}
            <div className="flex items-start space-x-2">
              <MapPin className="w-5 h-5 text-primary mt-1 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                {/* Tab Buttons */}
                <div className="flex flex-wrap gap-1 mb-3">
                  {locations.map((loc, i) => (
                    <button
                      key={i}
                      onClick={() => setActiveTab(i)}
                      className={`text-xs px-2 py-1 rounded transition-colors duration-200 whitespace-nowrap ${
                        activeTab === i
                          ? 'bg-primary text-white'
                          : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                      }`}
                    >
                      {loc.label}
                    </button>
                  ))}
                </div>

                {/* Active Location Content */}
                <div className="text-gray-300 text-sm">
                  <p className="font-semibold text-white mb-1">{locations[activeTab].name}</p>
                  {locations[activeTab].address && (
                    <p className="leading-relaxed">{locations[activeTab].address}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="text-center">
            <p className="text-gray-400 text-sm">© 2026 Solace Neuro. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;